import type { FC } from "react";

import { Typography } from "@aviary";

import * as styles from "./ProductSize.styles";

interface Props {
  descriptor: string | JSX.Element;
}

const isString = (prop): prop is String => typeof prop === "string";

const ProductSize: FC<Props> = ({ descriptor }) => {
  if (isString(descriptor) && descriptor.length === 0) {
    return null;
  }

  return (
    <Typography
      isMarginless
      data-testid="product-size"
      data-e2e="dosage-name"
      css={styles.productSize}
    >
      {descriptor}
    </Typography>
  );
};

export { ProductSize };
